/** Clicks on the session bar or the assistant bubble must not dismiss an open form. */

function outsideNode(event) {
  const original = event?.detail?.originalEvent?.target;
  const target = original || event?.target;
  if (!target) return null;
  return target.nodeType === 1 ? target : target.parentElement;
}

export function isChromeOverlayTarget(event) {
  const node = outsideNode(event);
  if (!node || typeof node.closest !== 'function') return false;
  return Boolean(
    node.closest('[data-session-banner], [data-testid="copilot-anchor"], [data-testid="copilot-panel"]')
  );
}

export function guardFormDismiss(handler) {
  return (event) => {
    if (isChromeOverlayTarget(event)) {
      event.preventDefault();
      return;
    }
    if (typeof handler === 'function') handler(event);
  };
}
